import {
  CLEAR_WELCOME_ALERTS_SPEED_DATA,
  GET_WELCOME_ALERTS_SPEED_CONTACTS_DATA,
  GET_WELCOME_ALERTS_SPEED_DATA,
  SET_WELCOME_ALERTS_SPEED_LOADING,
} from './WelcomeAlertsTypes'

const initState = {
  data: [],
  isLoading: false,
  contactsData: [],
}
export default (state = initState, action) => {
  switch (action.type) {
    case SET_WELCOME_ALERTS_SPEED_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case GET_WELCOME_ALERTS_SPEED_DATA:
      return {
        ...state,
        data: action.payload,
      }
    case GET_WELCOME_ALERTS_SPEED_CONTACTS_DATA:
      return {
        ...state,
        contactsData: action.payload,
      }
    case CLEAR_WELCOME_ALERTS_SPEED_DATA:
      return initState
    default:
      return state
  }
}
